import { Provider } from "react-redux";
import "./assets/styles/style.css";
import AddNewBook from "./components/AddNewBook";
import BookList from "./components/BookList";
import Navbar from "./components/Navbar";
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <Navbar />
        <main className="py-12 2xl:px-6">
          <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
            {/* Here Show book list */}
            <BookList />

            {/* Here Add New Book Section */}
            <AddNewBook />
          </div>
        </main>
      </div>
    </Provider>
  );
}

export default App;
